import { jsx as _jsx } from "react/jsx-runtime";
import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Accounting } from '~/types/accounting';
import { getAccountingDetails } from './accounting.utils';
export function QBOAccountField(param) {
    let { options, onChange, textFieldProps, selectedOption, testId, noOptionsText = "No ".concat(getAccountingDetails(Accounting.QBO).name, " accounts") } = param;
    return /*#__PURE__*/ _jsx(Autocomplete, {
        bi: {
            name: 'qbo_account'
        },
        testId: testId,
        value: selectedOption,
        options: options,
        onChange: (_, newOption)=>onChange(newOption),
        renderOption: (param)=>{
            let { name } = param;
            return /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                children: name
            });
        },
        getOptionSelected: (option, value)=>option.id === value.id,
        getOptionLabel: (option)=>option.name,
        filterOptions: (options, param)=>{
            let { inputValue } = param;
            return matchSorter(options, inputValue, {
                keys: [
                    'name'
                ]
            });
        },
        noOptionsText: noOptionsText,
        textFieldProps: textFieldProps,
        selectOnFocus: true,
        disableClearable: true,
        multiple: false,
        freeSolo: false
    });
}
